<form class="form" [formGroup]="prescriptionModel" (ngSubmit)="onSubmit()">
  @if (isLoadingMedicine) {
    <app-loading-progress-bar></app-loading-progress-bar>
  }
  @if (listLookupAdministrationLocation?.length > 0 && this.pharmacyConfig?.isActiveButtonInternalExternal) {
    <div class="row mb-3">
      <div class="col-12">
        <mat-label class="d-block mb-2"
          [ngClass]="{'invalid-label': prescriptionModel.get('idLookupAdministrationLocation')?.invalid && (prescriptionModel.get('idLookupAdministrationLocation')?.touched || prescriptionModel.get('idLookupAdministrationLocation')?.dirty)}">
          <b>Local de Administração*</b>
        </mat-label>
        <mat-button-toggle-group formControlName="idLookupAdministrationLocation" class="w-100 d-flex"
          [disabled]="readOnly"
          [ngClass]="{'invalid-toggle-group': prescriptionModel.get('idLookupAdministrationLocation')?.invalid && (prescriptionModel.get('idLookupAdministrationLocation')?.touched || prescriptionModel.get('idLookupAdministrationLocation')?.dirty)}">
          @for (location of listLookupAdministrationLocation; track location) {
            <mat-button-toggle
              [value]="location.idLookupAdministrationLocation" style="flex: 1;">
              {{ location.name }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
        @if (prescriptionModel.get('idLookupAdministrationLocation')?.invalid &&
          (prescriptionModel.get('idLookupAdministrationLocation')?.touched ||
          prescriptionModel.get('idLookupAdministrationLocation')?.dirty)) {
          <mat-error
            style="font-size: 75%; margin-top: 0.5rem;">
            O local de administração é obrigatório.
          </mat-error>
        }
      </div>
    </div>
  }

  <div formArrayName="listMedicine">
    @for (item of prescriptionModel?.get('listMedicine')['controls']; track item; let i = $index) {
      <div class="medicine-item-container mb-4"
        [formGroupName]="i">
        <div class="tag-container">
          @for (tag of item.get('listTags')?.value; track tag) {
            <span class="tag-header-prescription"
              [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 'color': 'white' } : {}">
              {{tag.tagName}}
            </span>
          }
        </div>
        <div class="row align-items-center mb-2">
          <div class="col-10 col-md-10">
            <mat-form-field appearance="outline" class="w-100 mb-0">
              <mat-label>Medicamento</mat-label>
              <mat-select formControlName="idMedicine" (selectionChange)="onChangeMedicine($event, i)"
                placeholder="Selecione ...">
                <input class="inputSearchSelect" type="text" (keyup)="onKey($event.target.value, i)"
                  placeholder="Pesquisar" autocomplete="off">
                  <mat-option [value]="null"> Selecione... </mat-option>
                  @for (medicineItem of selectedMedicineLists[i]; track medicineItem) {
                    <mat-option
                      [value]="medicineItem.medicine.idMedicine"
                      [disabled]="listIdSelectedMedicine.includes(medicineItem.medicine.idMedicine)">
                      {{medicineItem.medicine.medicineDescription}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="action-array col-2">
              @if (i === prescriptionModel.get('listMedicine')['controls'].length - 1) {
                <button
                  [disabled]="this.readOnly" class="panel-button" color="primary" mat-mini-fab type="button"
                  (click)="addNextMedicineInput()">
                  <mat-icon aria-hidden="false" aria-label="Adicionar">add</mat-icon>
                </button>
              }
              @if (prescriptionModel.get('listMedicine')['controls'].length > 1) {
                <button
                  [disabled]="this.readOnly" class="panel-button" color="primary" mat-mini-fab type="button"
                  (click)="removeMedicineInput(i)">
                  <mat-icon aria-hidden="false" aria-label="Remover">remove</mat-icon>
                </button>
              }
            </div>
          </div>
          <fieldset class="custom-fieldset">
            <legend>Detalhamento da Dosagem</legend>
            <div class="section-subtitle">VOLUME DE APRESENTAÇÃO</div>
            <div class="row">
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Dose por administração</mat-label>
                  <input formControlName="quantity" matInput [readonly]="this.readOnly" type="text"
                    appDecimalQuantityValidator>
                    @if (item.get('quantity')?.invalid) {
                      <mat-error>A quantidade máxima é 32767!</mat-error>
                    }
                    <mat-hint align="end">{{ getDoseToAdministeredText(item) }}</mat-hint>
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Unidade da dose</mat-label>
                    <mat-select formControlName="idDoseToAdministered" placeholder="Selecione ...">
                      @for (doseItem of listDoseToAdministered; track doseItem) {
                        <mat-option
                          [value]="doseItem.idDoseToAdministered"
                          [disabled]="isDoseToAdministeredDisabled(doseItem.idDoseToAdministered, i)">
                          {{doseItem.name}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              @if (totalDose24hLabels[i] !== null) {
                <div class="total-dose-container">
                  <mat-icon class="total-dose-icon">calculate</mat-icon>
                  <div class="total-dose-content">
                    <span class="total-dose-label">Total calculado para 24h</span>
                    <span class="total-dose-value">{{ totalDose24hLabels[i] }}</span>
                    @if (getDoseToAdministeredText(item)) {
                      <span class="total-dose-unit">
                        {{ getDoseToAdministeredText(item) }}
                      </span>
                    }
                    @if (totalEquivalent24hLabels[i]) {
                      <span class="total-dose-equivalent"
                        style="margin-left: 5px; font-weight: 500; color: #757575;">
                        {{ totalEquivalent24hLabels[i] }}
                      </span>
                    }
                  </div>
                  <mat-icon class="total-dose-readonly-icon"
                    matTooltip="Campo calculado automaticamente com base na dose e frequência informadas. Não editável.">
                    lock_outline
                  </mat-icon>
                </div>
              }
            </fieldset>
          </div>
        }
      </div>

      @if (this.justification) {
        <div class="justification-block">
          <p class="warning"><mat-icon>warning</mat-icon><b>Paciente Alérgico</b></p>
          <p>O paciente é alérgico a um dos princípios ativos deste medicamento</p>
          <b>Justificativa:</b>
          <p class="justification-text" [matTooltip]="justification">{{this.justification}}</p>
        </div>
      }

      @if (isFastTrack) {
        <div class="checkbox-container">
          <mat-checkbox [checked]="bypassPrescription" (change)="toggleBypassPrescription($event)">
            Listar todos
          </mat-checkbox>
        </div>
      }

      <div class="row mt-3">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Via</mat-label>
            <mat-select formControlName="idAdministrationType" (ngModelChange)="onChangeAdministrationType($event)"
              placeholder="Selecione ...">
              @for (item of administrationTypeList; track item) {
                <mat-option [value]="item.idMedicineAdministrationType">
                  {{item.medicineAdministrationTypeName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Frequência</mat-label>
            <mat-select formControlName="idFrequency" (ngModelChange)="onChangeFrequency($event)"
              placeholder="Selecione ...">
              @for (item of frequencyList; track item) {
                <mat-option [value]="item.idFrequency">
                  {{item.frequencyName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      @if (isFrequency) {
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Defina a frequência</mat-label>
              <mat-select formControlName="idSubFrequency">
                @for (item of this.listSubFrequency; track item) {
                  <mat-option [value]="item.idSubFrequency">
                    {{item.subFrequencyName}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      @if (this.prescriptionModel.get('idAdministrationType') && administrationTypeOthersEnum.valueOf() == this.prescriptionModel.get('idAdministrationType')?.value) {
        <div
          class="row">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descreva a Via</mat-label>
              <textarea [readonly]="this.readOnly" matInput formControlName="administrationType"></textarea>
            </mat-form-field>
          </div>
        </div>
      }

      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Diluição</mat-label>
            <mat-select (ngModelChange)="onChangeDilution($event)" formControlName="idDilution"
              placeholder="Selecione ....">
              @for (item of dilutionList; track item) {
                <mat-option [value]="item.idDilution">
                  {{item.dilutionName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Período de Tratamento</mat-label>
            <mat-select formControlName="idTreatmentPeriod" placeholder="Selecione ....">
              @for (item of treatmentList; track item) {
                <mat-option [value]="item.idTreatmentPeriod">
                  {{item.treatmentPeriodName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      @if (undiluted) {
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Quantidade</mat-label>
              <input formControlName="dilutionQuantity" matInput [readonly]="this.readOnly" type="text"
                oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                @if (prescriptionModel.get('dilutionQuantity')?.invalid) {
                  <mat-error>A quantidade máxima é
                  32767!</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Unidade</mat-label>
                <mat-select formControlName="idDilutionUnit" placeholder="Selecione ...">
                  @for (item of dilutionUnitList; track item) {
                    <mat-option [value]="item.idDilutionUnit">
                      {{item.dilutionUnitName}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }

        @if (this.prescriptionModel.get('idDilution') && this.prescriptionModel.get('idDilution')?.value == dilutionOthersEnum.valueOf()) {
          <div
            class="row">
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Descreva a diluição</mat-label>
                <textarea [readonly]="this.readOnly" matInput formControlName="dilution"></textarea>
              </mat-form-field>
            </div>
          </div>
        }

        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Observação</mat-label>
              <textarea [readonly]="this.readOnly" matInput formControlName="observation"
              placeholder="Escrever aqui ...."></textarea>
            </mat-form-field>
          </div>
        </div>

        @if (listKit != null && listKit.length > 0) {
          <div class="card-list">
            <span class="kits-vinculed">Kits Vinculados:</span>
            <div class="row row-list">
              @for (item of listKit; track item; let index = $index) {
                <div class="col-12 col-sm-6">
                  <div class="card-item" [class.selected]="isKitSelected(item)">
                    <div class="infos">
                      <span class="primary">{{item.kit.kitName}}</span>
                      <span class="secundary">{{item.kitType.kitTypeName}}</span>
                    </div>
                    <div class="actions">
                      <mat-checkbox [disabled]="readOnly" [checked]="isKitSelected(item)"
                      (change)="toggleKitSelection(item)"></mat-checkbox>
                      <a class="view-icon" (click)="openKit(item)">
                        <mat-icon aria-hidden="false" aria-label="Visualizar">visibility</mat-icon>
                      </a>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <div class="footer-actions d-flex justify-content-between mt-4 mb-2">
          @if (!this.readOnly) {
            <button mat-stroked-button type="button" class="btn-cancelar"
            (click)="clickCancel()">Cancelar</button>
          }
          @if (!this.readOnly) {
            <button mat-flat-button type="submit" class="btn-salvar">Salvar</button>
          }

          @if (this.readOnly) {
            <button mat-flat-button type="button" class="btn-salvar" style="width: 100%;"
            (click)="clickCancel()">Ok</button>
          }
        </div>
      </form>